import * as t from 'ts-codec';
import 'bson';
import { IdentityType, ProfileResource, RelationshipStatus, SexualOrientation } from '../types/types.js';
import { ResourceId } from '@journeyapps-labs/micro-codecs';
import { UserNotification } from '../types/types-notifications.js';
import { PaginatedRequest, PaginatedResponse } from './pagination.js';
import { GroupResource, PackResource } from '../types/types-groups.js';
export var ProfileRoutes;
(function (ProfileRoutes) {
    ProfileRoutes["ME"] = "/api/v1/profile/me";
    ProfileRoutes["NOTIFICATIONS"] = "/api/v1/profile/notifications";
    ProfileRoutes["PROFILE_PACKS"] = "/api/v1/profile/packs";
    ProfileRoutes["PROFILE_GROUPS"] = "/api/v1/profile/groups";
    ProfileRoutes["EDIT_PROFILE"] = "/api/v1/profile/edit";
    ProfileRoutes["UPDATE_LOCATION"] = "/api/v1/profile/update/location";
    ProfileRoutes["UPLOAD_PROFILE_IMAGE"] = "/api/v1/profile/upload-image";
    ProfileRoutes["UPLOAD_HEADER_IMAGE"] = "/api/v1/profile/upload-header";
    ProfileRoutes["UPLOAD_GALLERY_IMAGE"] = "/api/v1/profile/upload-gallery";
    ProfileRoutes["GET_PROFILE"] = "/api/v1/profile/get";
    ProfileRoutes["GET_PROFILES"] = "/api/v1/profile/get-all";
    ProfileRoutes["GET_PROFILE_GALLERY_IMAGES"] = "/api/v1/profile/get-gallery-images";
    ProfileRoutes["GET_PROFILE_GALLERY_IMAGE"] = "/api/v1/profile/get-gallery-image";
    ProfileRoutes["DELETE_PROFILE_GALLERY_IMAGE"] = "/api/v1/profile/delete-gallery-image";
})(ProfileRoutes || (ProfileRoutes = {}));
export var TrustedRoutes;
(function (TrustedRoutes) {
    TrustedRoutes["CREATE_PROFILE"] = "/api/v1/trusted/create-profile";
    TrustedRoutes["CHECK_PROFILE"] = "/api/v1/trusted/check-profile";
})(TrustedRoutes || (TrustedRoutes = {}));
//!------------ requests ------------
export const EditProfileRequest = t.object({
    about: t.string,
    sexual_orientation: t.Enum(SexualOrientation),
    identity: t.array(t.Enum(IdentityType)),
    relationship_status: t.Enum(RelationshipStatus)
});
export const CheckProfileResponse = t.object({
    exists: t.boolean.optional(),
    valid: t.boolean.optional()
});
export const UpdateLocationRequest = t.object({
    latitude: t.number,
    longitude: t.number
});
export const MeResponse = ProfileResource.and(t.object({
    new_user: t.boolean.optional()
}));
export const GetProfilesRequest = PaginatedRequest.and(t.object({
    location: t
        .object({
        cords: t
            .object({
            latitude: t.number,
            longitude: t.number
        })
            .optional(),
        distance_meters: t.number
    })
        .optional(),
    profile_name: t.string.optional()
}));
export const GetProfilesResponse = PaginatedResponse(ProfileResource);
export const GetProfilePacksResponse = t.array(PackResource);
export const GetProfileGroupsResponse = t.array(GroupResource);
export const ProfileGalleryImage = ResourceId.and(t.object({
    url: t.string
}));
export const GetProfileGalleryImagesResponse = PaginatedResponse(ProfileGalleryImage);
export const GetProfileGalleryImageResponse = ResourceId.and(t.object({
    url: t.string
}));
export const NotificationsResponse = t.array(UserNotification);
